import React from 'react';
import { Section, SectionHeading, Reveal } from '../shared/Section';
const outcomes = [{
  emoji: '🔥',
  title: 'Eliminar el dolor lumbar',
  text: 'Descomprimir la espalda baja, reducir la tensión muscular y recuperar comodidad en cada movimiento diario.'
}, {
  emoji: '⚡',
  title: 'Liberar el cuello y cervicales',
  text: 'Soltar la tensión acumulada en el cuello, trapecios y hombros con secuencias específicas de movilidad.'
}, {
  emoji: '🦵',
  title: 'Proteger y fortalecer las rodillas',
  text: 'Mejorar la movilidad de cadera y tobillo para reducir la carga articular y los crujidos cotidianos.'
}, {
  emoji: '🧘',
  title: 'Crear una rutina diaria sostenible',
  text: 'Armar una práctica de 15 a 20 minutos que puedas mantener en el tiempo sin depender de la motivación.'
}, {
  emoji: '📊',
  title: 'Entender tu cuerpo',
  text: 'Saber exactamente por qué tenés dolor y qué hacer en cada momento para aliviarlo de forma efectiva.'
}, {
  emoji: '🧠',
  title: 'Recuperar confianza en tu cuerpo',
  text: 'Romper el ciclo de frustración y volver a moverte con libertad, sin miedo a lesionarte o empeorar.'
}];
export function Outcomes() {
  return <Section id="beneficios" data-id="element-160" data-mp="3qo0qw84kc0b7">
      <Reveal data-id="element-161" data-mp="3qqwtwav9pf6i">
        <SectionHeading title={<>Al terminar este programa vas a poder…</>} data-id="element-162" data-mp="3vndfaxb31ffw" />
      </Reveal>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-163" data-mp="3gyzeerx8811z">
        {outcomes.map((o, i) => <Reveal key={o.title} index={i} data-id="element-164" data-mp="3lp7haqsectgb" data-mpi={i}>
            <div className="flex h-full flex-col rounded-2xl border border-sand-200 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-lg hover:shadow-forest-800/5" data-id="element-165" data-mp="3lr0ktx7pqxk3">
              <span className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-forest-50 text-xl" aria-hidden data-id="element-166" data-mp="3cxxdm6nnvgxw">
                {o.emoji}
              </span>
              <h3 className="font-display text-lg font-semibold text-forest-800" data-id="element-167" data-mp="32z7ts8c7fmf0">{o.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-forest-700/70" data-id="element-168" data-mp="2jul3y328jngs">{o.text}</p>
            </div>
          </Reveal>)}
      </div>
    </Section>;
}